<template>
  <div class="user-login">
    <div class="top">
      <div class="container">
        <img
          @click="pageHome"
          :src="BASE_URL + logo_url"
          alt="logo"
        />
      </div>
    </div>

    <div
      class="login-main"
      :style="`background-image:url(${bgcImgUrl})`"
    >
      <div class="container">
        <div class="form">
          <el-form
            :hide-required-asterisk="true"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="200px"
          >
            <img
              :src="loginLogoUrl"
              alt="logo"
            >
            <el-form-item
              :label="$t('register.account')"
              prop="usernum"
            >
              <el-input
                @keyup.native.13="submitForm('ruleForm')"
                v-model="ruleForm.usernum"
                maxlength="16"
                :placeholder="$t('rules.enterAcc')"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('register.psw')"
              prop="userpassword"
            >
              <el-input
                @keyup.native.13="submitForm('ruleForm')"
                type="password"
                v-model="ruleForm.userpassword"
                maxlength="16"
                :placeholder="$t('register.psw1')"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <router-link
              class="register"
              to="/register"
            >{{     $t('homepage.register')     }}</router-link>

            <ul class="langChange">
              <!-- <li @click="changeLange(item, index)" v-for="(item, index) in langArr" :key="item.id" :class="{isChangeLang:isActiveLength == index}">{{item.name}}</li> -->
            </ul>

            <el-form-item>
              <el-button
                :display="more"
                :class="{ disabled: ruleForm.usernum.length < 4 || ruleForm.userpassword.length < 6 }"
                type="primary"
                @click="submitForm('ruleForm')"
              >{{     $t('register.login')     }}</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>

    <foote />
  </div>
</template>

<script>
import store from "../../store/index.js";
import foote from "@/components/common/footer";
export default {
  data() {
    let checkAccount = (rule, value, callback) => {
      const reg = /^[\w]{4,16}$/;
      if (value === "") {
        callback(new Error(this.$t("register.accountEmpty")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("rules.account")));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      // const reg = /^[\w]{6,16}$/
      if (value === "") {
        callback(new Error(this.$t("register.pswEmpty")));
      }
      // else if (!reg.test(value)) {
      //   callback(new Error(this.$t('register.pswtip')))
      // }
      else {
        callback();
      }
    };
    return {
      logo_url: "", //logo地址
      bgcImgUrl: "", //背景图地址
      loginLogoUrl: "", //登录输入框的logo地址
      more: false, // 点击登录后在没有请求返回信息时都为true，防止多次点击登录事件
      ruleForm: {
        usernum: "",
        userpassword: "",
      },
      rules: {
        usernum: [{ validator: checkAccount, trigger: "blur" }],
        userpassword: [{ validator: validatePass, trigger: "blur" }],
      },
      langArr: [
        { id: 1, name: "简体中文", lang: "zh-cn" },
        { id: 2, name: "繁體中文", lang: "zh-hk" },
        { id: 3, name: "ENGLISH", lang: "en-us" },
      ],
      langStr: ["zh-cn", "zh-hk", "en-us"],
      isActiveLength: 0,
      jumpPage: "",
    };
  },
  created() {
    this.getAccessToken();
  },
  mounted() {
    this.getDefaulteLang();
    this.getHomeHeaderMenu();
  },
  computed: {
    isEnglish() {
      return this.$i18n.locale === "en-us";
    },
  },
  components: {
    foote,
  },
  methods: {
    getDefaulteLang() {
      setTimeout(() => {
        this.isActiveLength = this.langStr.indexOf(this.$i18n.locale);
      }, 1000);
    },
    //获取跳转目录
    getHomeHeaderMenu() {
      let success = (res) => {
        const {data} = res ?? []

        if(data?.length === 0 ){ return this.jumpPage  = '/homeindex'}
        
        if (data[0].url == "/") {
           data[0].url = "/homeindex";
        }
        this.jumpPage = data[0].url;
      };
      this.$ajax({
        url: "api/system/get_home_menu_cansee",
        method: "get",
        params: {},
        func: { success: success },
      });
    },

    getAccessToken() {
      let self = this;
      self.$ajax
        .get("/accessToken", {
          params: {
            company: "BL",
            device_name: "TE-0600R",
            data: {
              client_id: "20882088",
              secret: "nGk5R2wrnZqQ02bed29rjzax1QWRIu1O",
            },
          },
        })
        .then((response) => {
          localStorage.setItem("access_token", response.data.data.access_token);
          self.getLogo();
          self.getBackgroudPic();
          self.getTitle();
          this.getUseInfo();
        });
    },
    //获取logo
    getLogo() {
      let success = (res) => {
        this.logo_url = res.data[0].f_logo;
      };
      this.$ajax({
        url: "api/system/get_logo",
        method: "get",
        params: {},
        func: { success: success },
      });
    },
    //获取背景图
    getBackgroudPic() {
      let success = (res) => {
        this.bgcImgUrl = this.BASE_URL + res.data.back_image;
        this.loginLogoUrl = this.BASE_URL + res.data.logo_image;
      };
      this.$ajax({
        url: "api/system/login_set",
        method: "get",
        params: {},
        func: { success: success },
      });
    },
    // 点击logo事件
    pageHome() {
      let path = window.location.href;
      window.location.href = window.location.origin;
    },
    submitForm(name) {
      if(this.ruleForm.usernum.length < 4 || this.ruleForm.userpassword.length < 6) {
        return
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (!window.navigator.onLine) {
            this.$message.error(this.$t("homepage.connect"));
            return;
          }
          this.more = true;
          let success = (res) => {
            this.$message.success(res.msg);
       
            localStorage.setItem("token", res.data);
            this.getUseInfo();
          };
          let fail = (err) => {
            this.$message.error(err.msg);
            this.more = false;
          };
          let params = {
            usernum: this.ruleForm.usernum,
            userpassword: this.ruleForm.userpassword,
          };

          this.$ajax.post("api/login/login", params, {
            func: { success, fail },
          });
        } else {
          this.more = false;
        }
      });
    },

    /**
     * 获取用户信息
     */
    getUseInfo(checkLogin) {
      const success = (res) => {
        let data = res.data;
        console.log("登录时获取到用信息", data);
        // 缓存获取到的用户信息
        sessionStorage.setItem("manage", JSON.stringify(data.manage));
        sessionStorage.setItem("login_out", data.logout_url);
        sessionStorage.setItem("user_info_str", JSON.stringify(data.userinfo));
        sessionStorage.setItem("manage_url", data.manage_url);
        sessionStorage.setItem("ItcJwtToken", data.userinfo.ItcJwtToken);

        store.commit("SET_USERINFO", data.userinfo);
        this.$g.user_id = data.userinfo.id;
        this.jumpPage && this.$router.push(this.jumpPage)

        setTimeout(() => {
          // console.log('4跳转至', window.location.origin + this.jumpPage)
          // window.location.href = window.location.origin + this.jumpPage;
        }, 1000);
      };

      const fail = (err) => {};

      this.$ajax.get("api/login/login", {
        func: { success: success, fail: fail },
      });
    },

    changeLange(item, index) {
      this.isActiveLength = index;
      const success = (res) => {
        this.$i18n.locale = item.lang;
        Cookies.set("think_var", item.lang);
      };

      this.$ajax.get("api/login/change_lang", {
        params: { default_lang: item.lang },
        func: { success },
      });
    },
  },
};
</script>

<style lang="scss">
.user-login {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 1152px;
  min-height: 880px;
  background: #fff;

  .top {
    background: #fff;

    .container {
      margin: 0 auto;
      width: 1152px;
      height: 120px;
      display: flex;
    align-items: center;

      img {
        // margin-top: 18px;
        width: 235px;
        height: 48px;
        cursor: pointer;
        object-fit: contain;
      }
    }
  }

  .login-main {
    flex: 1;
    min-width: 100%;
    min-height: 700px;
    background-repeat: no-repeat;
    // background-size: 100% 100%;
    // background-position: center top;
    background-size: cover;
    background-position: 30% top;

    .container {
      position: relative;
      margin: 0 auto;
      width: 1152px;
      height: 100%;

      .form {
        border-radius: 4px;
        overflow: hidden;
        position: absolute;
        top: 130px;
        right: 0;
        padding-top: 10px;
        width: 340px;
        height: 430px;
        background: #0059aa;

        .el-form {
          height: 100%;
          background: #e9eef3;

          > img {
            display: block;
            margin: 0 auto;
            padding-top: 35px;
            width: 94px;
            height: 88px;
          }

          .el-form-item {
            padding: 0 40px;
            margin: 0;

            .el-form-item__label {
              padding-top: 22px;
              display: block;
              text-align: left;
              float: none;
              font-size: 12px;
              color: #333333;
              line-height: 32px;
            }

            .el-form-item__content {
              margin: 0 !important;
              line-height: 36px;

              .el-input__inner {
                padding: 0;
                background: #e9eef3 !important;
                border: 0 none;
                height: 36px;
                border-bottom: 1px solid #c5c5c5;
                color: #000;

                &::-webkit-input-placeholder {
                  color: #888888;
                }
              }
            }

            &:last-child {
              position: absolute;
              bottom: 20px;
              width: 100%;
              padding: 0;

              .el-form-item__content {
                margin: 0 !important;

                .el-button {
                  background-color: #0059aa;
                  border: 0 none;
                  margin: 0 auto;
                  display: block;
                  width: 260px;

                  &.disabled {
                    background-color: gray;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .register {
    display: block;
    text-align: right;
    margin: 10px 40px 30px 0;
    color: blue;
    background: transparent;
    border: none;
  }

  .langChange {
    display: flex;
    justify-content: center;

    li {
      width: 80px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border: 2px solid #fff;
      border-radius: 3px;
      cursor: pointer;
    }

    li + li {
      margin-left: 1px;
    }

    .isChangeLang {
      background-color: #888;
      color: #fff;
      border: 2px solid #888;
    }
  }
}
</style>